import Vue from "vue";
import moment from "moment";
import get from "lodash/get";
import set from "lodash/set";
import pick from "lodash/pick";
import omit from "lodash/omit";
import { helpers } from "vuelidate/lib/validators";
import RECEIPT_TYPES from "@/assets/tables/receipt_types.json";

function AppError(message = "未知錯誤") {
  this.name = "AppError";
  this.message = message;
}

AppError.prototype = Object.create(Error.prototype);
AppError.prototype.constructor = AppError;

const firebaseErrors = {
  "permission-denied": "沒有權限進行此操作",
  "deadline-exceeded": "連線逾時，請檢查網路連線速度"
};

function parseResponse(r) {
  if (r instanceof AppError && r.name === "AppError") {
    return r.message;
  }

  if (r instanceof Error) {
    if (get(r, "code")) {
      return firebaseErrors[get(r, "code")];
    }

    if (get(r, "response.data.message")) {
      return get(r, "response.data.message");
    }

    return "未知錯誤";
  }

  return r.data;
}

function buildForm(fields, vm) {
  const dict = fields.reduce((acc, field) => {
    const obj = acc;
    const val = vm[field];
    const emptyKeywords = [null, undefined, ""];
    const isEmpty = emptyKeywords.indexOf(val) !== -1;

    obj[field] = isEmpty ? null : vm[field];

    return obj;
  }, {});

  return JSON.parse(JSON.stringify(dict));
}

function parseTimestamp(timestamp) {
  return timestamp ? moment(timestamp.toDate()).format("YYYY-MM-DD") : "";
}

const validators = {
  length: length =>
    helpers.withParams(
      { type: "length" },
      value => !helpers.req(value) || helpers.len(value) === length
    ),
  ref: (prop, fn) =>
    helpers.withParams({ type: "requireRef", prop }, (value, parentVm) => {
      const ref = helpers.ref(prop, this, parentVm);
      return fn(value, ref);
    })
};

function parseReceiptType(item) {
  let type = RECEIPT_TYPES[item.type].value;

  switch (type) {
    case "donation":
      type = `樂捐-${item.donation}`;
      break;
    case "other":
      type = `其他-${item.other}`;
      break;
    default:
      type = RECEIPT_TYPES[item.type].text;
  }

  return type;
}

function docsParser(docs) {
  if (!(this instanceof docsParser)) return new docsParser(docs);

  this.docs = docs;
}

docsParser.prototype = {
  toList() {
    return this.docs.reduce((acc, doc) => {
      const obj = doc.data();
      obj.id = doc.id;
      acc.push(obj);
      return acc;
    }, []);
  }
};

function parseDbSnap(snap) {
  let res;

  if (snap.size) {
    res = [];
    snap.forEach(doc => {
      const data = doc.data();
      const id = doc.id;
      set(data, "temp.id", id);
      res.push(data);
    });
  } else {
    const data = snap.data();
    const id = data.id;
    set(data, "temp.id", id);
    res = data;
  }

  return res;
}

const Utils = {
  install: function(Vue, options) {
    Vue.prototype.$utils = {
      AppError,
      parseResponse,
      buildForm,
      parseTimestamp,
      parseReceiptType,
      validators,
      docsParser,
      get,
      set
    };

    Vue.prototype.$u = {
      AppError,
      parseResponse,
      buildForm,
      parseTimestamp,
      parseReceiptType,
      validators,
      docsParser,
      get,
      set,
      omit,
      pick,
      parseDbSnap
    };
  }
};

Vue.use(Utils);
